import React from 'react';
import { Box, Checkbox } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CommentCell from './CommentCell';
import TagAutocomplete from './TagAutocomplete';

/**
 * TransactionGrid component for displaying the transaction data table
 */
const TransactionGrid = ({
  filteredData,
  allTags,
  setAllTags,
  setTableData,
  handleTaxChange,
  handleCommentChange,
  saveTableData,
  addHistoryEntry,
  historyManager
}) => {
  // Column definitions for DataGrid
  const columns = [
    { field: 'date', headerName: 'Date', sortable: true, width: 100 },
    { field: 'amount', headerName: 'Amount', sortable: true, type: 'number', width: 110 },
    { field: 'description', headerName: 'Description', sortable: true, minWidth: 150, flex: 1 },
    { field: 'description2', headerName: 'Description2', sortable: true, minWidth: 150, flex: 1 },
    {
      field: 'tags',
      headerName: 'Tags',
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <TagAutocomplete
          value={params.value || []}
          options={allTags}
          rowData={params.row}
          addHistoryEntry={addHistoryEntry}
          historyManager={historyManager}
          onChange={(updatedTags) => {
            // Add any new tags to the allTags set
            updatedTags.forEach(tag => {
              if (!allTags.has(tag.toLowerCase().trim())) {
                setAllTags(prev => new Set([...prev, tag.toLowerCase().trim()]));
              }
            });

            setTableData(prevData => {
              const newData = [...prevData];
              const index = newData.findIndex(row => row.id === params.row.id);
              if (index !== -1) {
                newData[index] = {
                  ...newData[index],
                  tags: updatedTags
                };
              }
              saveTableData(newData);
              return newData;
            });
          }}
        />
      )
    },
    {
      field: 'tax',
      headerName: 'Tax',
      sortable: true,
      width: 80,
      renderCell: (params) => (
        <Checkbox
          checked={params.value}
          onChange={() => handleTaxChange(params.row.id)}
        />
      )
    },
    {
      field: 'comments',
      headerName: 'Comments',
      sortable: true,
      minWidth: 150,
      flex: 1,
      editable: false,
      renderCell: (params) => (
        <Box
          sx={{ width: '100%' }}
          onClick={(e) => e.stopPropagation()}
        >
          <CommentCell
            id={params.row.id}
            value={params.row.comments}
            onSave={handleCommentChange}
          />
        </Box>
      )
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <DataGrid
        getRowHeight={() => 'auto'}
        rows={filteredData}
        columns={columns}
        initialState={{
          pagination: { paginationModel: { pageSize: 10 } },
        }}
        pageSizeOptions={[10, 25, 50]}
        disableSelectionOnClick
        disableColumnMenu
      />
    </Box>
  );
};

export default TransactionGrid;